<template>
  <div style="cursor: pointer">
    <div class="card-title"> {{ getCardTitle }}</div>
    <div style="display: flex; margin: 8px 0">
        <div class="card-subtitle">{{ getCardType }}</div>
        <div class="card-date">{{ formatDate }}</div>
    </div>
  </div>
</template>

<script>
import Helpers from '../utils/helpers'
import get from 'lodash/get'

export default {
  name: 'diseaseCardSearch',
  props: {
    diseaseCard: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    formatDate() {
        let options = { year: '2-digit', month: '2-digit', day: '2-digit' }
        return Helpers.ciiFormatDate(this.diseaseCard.eventDate, options)
    },
    getCardTitle() {
        return get(this.diseaseCard, 'data.codes[0].name', '')
    },
    getCardType() {
        return Helpers.capitalizedText(get(this.diseaseCard, 'type', ''))
    }
  }
}
</script>

<style>
.card-title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    margin: 8px 0;
    letter-spacing: 0.02em;
    color: #161616;
}
.card-title:hover {
  text-decoration: underline;
}
.card-subtitle {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #161616;
    width: 80%;
}
.card-date {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    letter-spacing: 0.01em;
    color: #565963;
    width: 20%;
}
</style>
